import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="relative min-h-screen flex flex-col justify-center items-center bg-warm-white px-4 py-20 overflow-hidden" data-id="element-102">
      <div className="max-w-6xl mx-auto w-full z-10" data-id="element-103">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-104">
          {/* Text column */}
          <div className="text-center md:text-left" data-id="element-105">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} className="mb-12" data-id="element-106">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy mb-6 leading-tight" data-id="element-107">
                La ansiedad funcional no siempre se ve como crisis.{' '}
                <br className="hidden md:block" data-id="element-108" />
                <span className="text-teal" data-id="element-109">
                  A veces se ve como rendimiento.
                </span>
              </h1>
            </motion.div>

            <motion.ul variants={container} initial="hidden" animate="show" className="space-y-4 mb-12 text-xl md:text-2xl text-gray-700 font-medium max-w-2xl mx-auto md:mx-0 text-left" data-id="element-110">
              {['Cumples', 'Produces', 'Resuelves', 'Sostienes a otros', 'Sigues aunque estés cansado/a'].map((text, index) => <motion.li key={index} variants={item} className="flex items-center gap-3" data-id="element-111">
                  <span className="h-2 w-2 rounded-full bg-teal flex-shrink-0" data-id="element-112" />
                  {text}
                </motion.li>)}
            </motion.ul>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 1.5,
            duration: 1
          }} className="space-y-8" data-id="element-113">
              <p className="text-2xl md:text-3xl text-navy font-semibold italic" data-id="element-114">
                Y un día te das cuenta de que "seguir" ya no se siente como
                fuerza.
                <br data-id="element-115" />
                <span className="text-teal block mt-2" data-id="element-116">
                  Se siente como supervivencia.
                </span>
              </p>

              <div className="pt-8 flex flex-col sm:flex-row gap-4 md:justify-start justify-center" data-id="element-117">
                <Button scrollTo="precio" variant="primary" data-id="element-118">
                  Quiero mi Reset de 10 Minutos
                </Button>
                <Button scrollTo="problem" variant="outline" data-id="element-119">
                  Leer más <ArrowDownIcon className="ml-2 h-4 w-4" data-id="element-120" />
                </Button>
              </div>
            </motion.div>
          </div>

          {/* Product image column */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.4,
          ease: 'easeOut'
        }} className="flex justify-center md:justify-end" data-id="element-121">
            <img src="https://cdn.magicpatterns.com/uploads/pnmLnCBDvUJF6XXtrV8i5k/heylloyd-image-RESET_10_MIN.png" alt="El Reset de 10 Minutos para tu Sistema Nervioso — mockup en tablet y teléfono" className="w-full max-w-md md:max-w-lg rounded-2xl shadow-2xl" data-id="element-122" />
          </motion.div>
        </div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30" data-id="element-123">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-teal/20 blur-3xl" data-id="element-124" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-navy/10 blur-3xl" data-id="element-125" />
      </div>
    </section>;
}